import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Toast } from '../../../../../UILibrary';
import { definedTranslation } from '../i18n';

export const IncompleteProfileToast = () => {
  const intl = useIntl();
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => {
    setIsOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const handleClose = () => {
    setIsOpen(false);
    document.body.style.overflow = 'auto';
  };

  useEffect(() => {
    window.addEventListener('open-incomplete-profile-toast', handleOpen);

    return () => {
      window.removeEventListener('open-incomplete-profile-toast', handleOpen);
    };
  }, []);

  return (
    <Toast isOpen={isOpen} handleClose={handleClose}>
      {intl?.formatMessage(definedTranslation.incompleteProfileToast.title)}
    </Toast>
  );
};
